import OurMission from './OurMission'

export default OurMission
